import type { EntityDetailMetadata } from '@zag/ui';

export const PLANNING_ENTITY_DETAIL_METADATA = [
  {
    entity: 'skill',
    route: '/skills-catalog/:id',
    titleKey: 'settings.skillsCatalog.title',
    sections: [
      { id: 'details', titleKey: 'settings.skillsCatalog.sections.details' },
      { id: 'rating', titleKey: 'settings.skillsCatalog.sections.rating' },
      {
        id: 'custom-properties',
        titleKey: 'common.customProperties.sectionTitle',
        visibleWhen: { mode: 'all', permissions: ['skills:read'] },
        requiresEntityId: true,
      },
    ],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: { mode: 'all', permissions: ['skills:update'] }, intent: 'mutation' },
      {
        id: 'delete',
        labelKey: 'common.delete',
        visibleWhen: { mode: 'all', permissions: ['skills:delete'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
    ],
  },
  {
    entity: 'team',
    route: '/teams/:id',
    titleKey: 'navigation.teams',
    sections: [{ id: 'details', titleKey: 'settings.teams.sections.details' }],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: { mode: 'all', permissions: ['teams:update'] }, intent: 'mutation' },
      {
        id: 'delete',
        labelKey: 'common.delete',
        visibleWhen: { mode: 'all', permissions: ['teams:delete'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
    ],
  },
  {
    entity: 'department',
    route: '/departments/:id',
    titleKey: 'navigation.departments',
    sections: [
      { id: 'details', titleKey: 'settings.departments.sections.details' },
      { id: 'teams', titleKey: 'settings.departments.sections.teams', requiresEntityId: true },
      { id: 'leadership', titleKey: 'settings.departments.sections.leadership', requiresEntityId: true },
    ],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: { mode: 'all', permissions: ['departments:update'] }, intent: 'mutation' },
      {
        id: 'delete',
        labelKey: 'common.delete',
        visibleWhen: { mode: 'all', permissions: ['departments:delete'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
    ],
  },
  {
    entity: 'shift-definition',
    route: '/shift-definitions/:id',
    titleKey: 'settings.shiftDefinitions.title',
    sections: [
      { id: 'details', titleKey: 'settings.shiftDefinitions.sections.details' },
      { id: 'shift-units', titleKey: 'settings.shiftDefinitions.sections.shiftUnits', requiresEntityId: true },
      { id: 'requirements', titleKey: 'settings.shiftDefinitions.sections.requirements', requiresEntityId: true },
      {
        id: 'custom-properties',
        titleKey: 'common.customProperties.sectionTitle',
        visibleWhen: { mode: 'all', permissions: ['shifts:read'] },
        requiresEntityId: true,
      },
    ],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: { mode: 'all', permissions: ['shifts:update'] }, intent: 'mutation' },
      {
        id: 'delete',
        labelKey: 'common.delete',
        visibleWhen: { mode: 'all', permissions: ['shifts:delete'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
    ],
  },
  {
    entity: 'strategy',
    route: '/settings/strategies/:id',
    titleKey: 'strategies.title',
    sections: [
      { id: 'details', titleKey: 'strategies.sections.details' },
      { id: 'schedule', titleKey: 'strategies.sections.schedule' },
      { id: 'solver', titleKey: 'strategies.sections.solver' },
    ],
    actions: [
      { id: 'save', labelKey: 'common.save', visibleWhen: { mode: 'all', permissions: ['strategies:update'] }, intent: 'mutation' },
      {
        id: 'delete',
        labelKey: 'common.delete',
        visibleWhen: { mode: 'all', permissions: ['strategies:delete'] },
        requiresEntityId: true,
        intent: 'mutation',
      },
    ],
  },
] satisfies readonly EntityDetailMetadata[];
